import { render, staticRenderFns } from "./SubscriptionInvoices.vue?vue&type=template&id=be2e4958&scoped=true&"
import script from "./SubscriptionInvoices.vue?vue&type=script&lang=js&"
export * from "./SubscriptionInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e4958",
  null
  
)

export default component.exports